export const home = () => (
  <path
    d="M4 8.182L1 10.5 12 2l11 8.5-3-2.318V20a2 2 0 01-2 2H6a2 2 0 01-2-2V8.182z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
